export function runPhaseStageIndex(
  phase: string,
  stageCount: number,
  persistedIndex: number,
) {
  if (stageCount < 1) return 0;
  if (["self_check", "validating", "structuring"].includes(phase)) {
    return Math.max(0, stageCount - 2);
  }
  if (["writing", "preparing_response"].includes(phase)) {
    return Math.max(0, stageCount - 3);
  }
  if (phase === "researching") return Math.min(1, stageCount - 1);
  return Math.max(0, persistedIndex);
}

export function advanceVisibleStage(
  highestSeen: number,
  persistedIndex: number,
  runPhaseIndex: number,
) {
  return Math.max(0, highestSeen, persistedIndex, runPhaseIndex);
}
